/**
 * HITL updated-argument path helpers.
 * Paths are dotted leaves from Horizon message processing (`updated_arg_paths`),
 * matching NestedArgField valuePath (including `user_input.` when unwrapped).
 */

const PREVIOUS_VALUE_MAX_CHARS = 120;

export function joinArgPath(parent: string, key: string): string {
  return parent ? `${parent}.${key}` : String(key);
}

export function normalizeUpdatedArgPaths(value: unknown): string[] {
  if (typeof value === "string" && value.length > 0) return [value];
  if (!Array.isArray(value)) return [];
  return value.filter((item): item is string => typeof item === "string" && item.length > 0);
}

export function isUpdatedArgPath(updatedPaths: string[] | undefined, path: string): boolean {
  if (!path || !Array.isArray(updatedPaths) || updatedPaths.length === 0) return false;
  return updatedPaths.includes(path);
}

export function getValueAtPath(obj: unknown, path: string): unknown {
  if (!path) return obj;
  if (obj == null || typeof obj !== "object") return undefined;
  return path.split(".").reduce<unknown>((acc, key) => {
    if (acc == null || typeof acc !== "object") return undefined;
    return (acc as Record<string, unknown>)[key];
  }, obj);
}

export function formatHitlArgValue(value: unknown): string {
  if (value === undefined || value === null) return "empty";
  if (typeof value === "boolean") return value ? "true" : "false";
  if (typeof value === "string") return value.trim() === "" ? "empty" : value;
  if (typeof value === "number") return String(value);
  try {
    return JSON.stringify(value);
  } catch {
    return String(value);
  }
}

export function formatHitlPreviousArgValue(value: unknown): string {
  const formatted = formatHitlArgValue(value);
  if (formatted.length <= PREVIOUS_VALUE_MAX_CHARS) return formatted;
  return `${formatted.slice(0, PREVIOUS_VALUE_MAX_CHARS - 1)}…`;
}
